module.exports = function getResource(label, vars = []) {
    let resources = {
        viewNumber: `Afficher ${vars[0]}`,
        viewAll: 'Tout afficher'
    };
    return resources[label];
};
